<template>
    <TopCard v-if="posts" :post="posts[0]"></TopCard>
    <GridDisplay title="Recomendados para ti" :method="setSong" :posts="posts"/>
</template>

<script>
import TopCard from '@/components/TopCard.vue';
import GridDisplay from '@/components/GridDisplay.vue';
export default {
    components: { TopCard, GridDisplay },
    name:'RockView',
    data() {
        return{
            posts: [],
        }    
    },
    mounted(){       
          const url= this.baseUrl + '/playlist/1306931615';
          fetch(url)
            .then(response=>response.json())
            .then(json=>this.posts = json.tracks.data);        
    },
    methods:{
        setSong(song){
            const songId = song.id
            const url = this.baseUrl + '/track/'+songId
            fetch(url)
                .then(response=>response.json())
                .then(json=> localStorage.setItem('currentSong', JSON.stringify(json)));
        }
    }
}
</script>